import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DragSource as dragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';

import DnDItemTypes from '../common/DynamicDnD/DnDItemTypes';
import GenericInlineEdit from '../common/GenericInlineEdit';

import { crosstabViewTextEllipsis, shortLabelText } from '../../util/CrosstabUtils';

const dragItemsSource = {
  beginDrag(props) {
    const selectedNodes = props.getSelectedTargets();
    return { gridType: props.gridType, selectedNodes };
  },
};
function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}
class DraggableToolPaletteItem extends Component {
  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true,
    });
  }

  render() {
    const {
      connectDragSource,
      isDragging,
      gridEntry,
      index,
      gridType,
      selectGridItem,
      handleBaseSelectionChange,
      updateGridData,
      allSelectedKPIsInfo,
      tooltipVal,
      toggleLabelFlag,
      crosstabViewFlag,
    } = this.props;
    let gridTitle = gridEntry.title;
    const kpiName = gridEntry.keyword;
    if (gridType !== 'BasesDataGrid' && crosstabViewFlag) {
      gridTitle = gridEntry.isLabelUpdated ? gridEntry.title : tooltipVal;
    }
    if (
      allSelectedKPIsInfo &&
      allSelectedKPIsInfo[kpiName] &&
      allSelectedKPIsInfo[kpiName].modeled === true
    ) {
      gridTitle = `${String.fromCharCode(10020)} ${gridEntry.tooltipVal}`;
    }

    return connectDragSource(
      <p
        className="crosstab-recent-item-title"
        style={{
          opacity: isDragging ? 0.5 : 1,
        }}
        onClick={e => {
          selectGridItem(e, gridEntry.id, index);
          if (gridType === 'BasesDataGrid') {
            handleBaseSelectionChange(gridEntry.id, gridType);
          }
        }}
        title={tooltipVal || gridEntry.title}
      >
        <GenericInlineEdit
          originalLabel={gridEntry.originalTitle}
          validate={text => text.length > 0 && text.length < 64}
          activeClassName="editing"
          text={toggleLabelFlag || gridType === 'BasesDataGrid' || gridTitle.length < 25 ? crosstabViewTextEllipsis(gridType, gridTitle) : shortLabelText(gridTitle)}  // was generating an error
          toggleLabel={toggleLabelFlag}
          paramName="title"
          crosstabViewFlag={crosstabViewFlag}
          change={updatedObjectProps => {
            if (
              this.props.gridType === 'ColumnsDataGrid' ||
              this.props.gridType === 'BasesDataGrid' ||
              this.props.gridType === 'RowsDataGrid'
            ) {
              this.props.updateCrosstabTitleHeader({
                originalTitle: gridEntry.originalTitle.trim(),
                updatedTitle: updatedObjectProps.title.trim(),
                gridCategory: this.props.gridType,
                keyword: gridEntry.keyword,
              });
            }
            const latestUpdatedProps = {
              ...updatedObjectProps,
              originalTitle: updatedObjectProps.title,
            };
            updateGridData(gridEntry, latestUpdatedProps, gridType);
          }
          }
          showFootNoteIcon={gridEntry.footnotes ? gridEntry.footnotes : []}
          crosstabFootNotes={this.props.crosstabFootNotes}
        />
      </p>,
    );
  }
}

DraggableToolPaletteItem.propTypes = {
  connectDragPreview: PropTypes.func,
  connectDragSource: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  gridEntry: PropTypes.shape({
    footnotes: PropTypes.instanceOf(Array),
  }),
  index: PropTypes.number,
  gridType: PropTypes.string,
  handleBaseSelectionChange: PropTypes.func,
  selectGridItem: PropTypes.func,
  updateGridData: PropTypes.func,
  allSelectedKPIsInfo: PropTypes.shape({}),
  tooltipVal: PropTypes.string,
  crosstabViewFlag: PropTypes.bool,
  crosstabFootNotes: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    allSelectedKPIsInfo: state.crosstab.allSelectedKPIsInfo,
    crosstabFootNotes: state.study.crosstabFootNotes,
  };
}

export default dragSource(
  DnDItemTypes.DnD_ITEM_TYPE_5,
  dragItemsSource,
  collect,
)(connect(mapStateToProps)(DraggableToolPaletteItem));
